import { Gift, GiftsState } from 'acscp/store';
import giftsComparison from 'acscp/store/helpers/sortGifts';

export interface LoyaltyGiftCategory {
    id: string;
    name: string;
    gifts: Gift[];
}

const giftCategoriesComparison = (category1: LoyaltyGiftCategory, category2: LoyaltyGiftCategory) => {
    return category1.name > category2.name ? 1 : -1;
};

export const getCategorisedGifts = (giftsState: GiftsState): LoyaltyGiftCategory[] =>
    Object.keys(giftsState.giftCategories).map(catId => {
        const category = giftsState.giftCategories[catId];
        return {
            id: category.id,
            name: category.name,
            gifts: Object.keys(giftsState.giftsList).map(giftId => giftsState.giftsList[giftId])
                .filter(g => g.categoryId === category.id)
                .sort(giftsComparison)
        };
    })
        .filter(c => c.gifts.length > 0)
        .sort(giftCategoriesComparison);

export const getCanAffordGifts = (giftsState: GiftsState): Gift[] =>
    Object.keys(giftsState.giftsList).map(giftId => giftsState.giftsList[giftId])
            .filter(g => g.price <= (giftsState.balance || 0))
            .sort(giftsComparison);
